import React from 'react';

import './ClientLogin.scss';
import { User, Login, Currency, Exchange } from '../../assets';
import ServicesCard from './Services.Card';

export const ServicesClientLogin: React.FC = React.memo(() => {
    return (
        <div className='client-login'>
        </div>
    );
});
